import { useTranslation } from "react-i18next";
import sunIcon from "../assets/sun-icon.svg";
import moonIcon from "../assets/moon-icon.svg";
import useIsMobile from "../hooks/useIsMobile";

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}

const darkModeGradient =
  "linear-gradient(90deg, #f0eeff 0%, #e8e4ff 100%)";

const darkIndicatorGradient =
  "linear-gradient(147.51deg, rgb(0, 0, 70) 0.94%, rgb(0, 0, 143) 98%)";

export default function ThemeToggle({ isDark, onToggle }: ThemeToggleProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <button
      type="button"
      onClick={onToggle}
      id="themeToggle"
      aria-label={
        isDark ? t("themeToggle.switchToLight") : t("themeToggle.switchToDark")
      }
      className={
        isMobile
          ? "flex h-8 w-8 items-center justify-center rounded-full p-[3.2px] transition-colors duration-300"
          : "flex items-center rounded-full p-[4.2px] sm:p-[5.714px] flex-shrink-0 transition-colors duration-300 h-[25.2px] w-[25.2px] sm:w-[74.286px] sm:h-[40px]"
      }
      style={{
        background: isDark ? darkModeGradient : "var(--cta-gradient)",
        border: "none",
      }}
    >
      {isMobile ? (
        <div
          className=" flex h-full w-full items-center justify-center rounded-full"
          style={{
            background: isDark ? darkIndicatorGradient : "#fdfdfd",
          }}
        >
          <img
            src={isDark ? moonIcon : sunIcon}
            className={isDark ? "h-3.5 w-3.5" : "h-6 w-6"}
            alt=""
          />
        </div>
      ) : (
        <div
          className="rounded-full overflow-hidden flex-shrink-0 transition-transform duration-300 h-[18.2px] w-[18.2px] sm:h-[28.571px] sm:w-[28.571px]"
          style={{
            background: isDark ? darkIndicatorGradient : "#fdfdfd",
            transform: isDark ? "translateX(34.287px)" : "translateX(0)",
          }}
        >
          <div
            className="flex flex-col transition-transform duration-300 "
            style={{
              transform: isDark
                ? "translateY(-22.0px) translateX(6.571px)"
                : "translateY(0)",
            }}
          >
            <img
              src={sunIcon}
              className="w-[22.571px] h-[22.571px] sm:w-[28.571px] sm:h-[28.571px]"
              alt=""
              style={{ flexShrink: 0 }}
            />
            <img
              src={moonIcon}
              alt=""
              style={{ width: "15.571px", height: "15.571px", flexShrink: 0 }}
            />
          </div>
        </div>
      )}
    </button>
  );
}
